import {
  faAddressCard,
  faChartLine,
  faListOl,
  faPeopleArrows,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StepType, TourProvider, useTour } from "@reactour/tour";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import WrappedTour from "./WrappedTour";
import { ReactComponent as TourIcon } from "shared/assets/images/tour-icon.svg";

interface TourStepProps {
  text: string;
  icon?: ReactNode;
}
const TourStep: React.FC<TourStepProps> = (props) => {
  const { text, icon } = props;
  const { currentStep, setIsOpen, setCurrentStep, steps } = useTour();
  const { t } = useTranslation("radar");
  const last = currentStep === steps.length - 1;
  const totalSteps = steps.length;
  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          backgroundColor: "#1B1B1B",
          color: "#e4bc5c",
          padding: 12,
          display: "flex",
          alignItems: "center",
        }}
      >
        {icon}
      </div>
      <div
        style={{
          padding: 12,
        }}
      >
        <div>{text}</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ color: "#98A2B3" }}>
            {t("components.Tour.of", {
              from: currentStep + 1,
              to: totalSteps,
            })}
          </div>
          <button
            className="border-preenchido-colorido"
            style={{
              backgroundSize: "cover",
              color: "#fff",
            }}
            onClick={() => {
              if (last) {
                setCurrentStep(0);
                setIsOpen(false);
              } else {
                setCurrentStep((s) => (s === steps.length - 1 ? 0 : s + 1));
              }
            }}
          >
            {last ? "fechar!" : "próximo"}
          </button>
        </div>
      </div>
    </div>
  );
};
const Tour: React.FC<any> = (props) => {
  const { children } = props;
  const { t } = useTranslation("radar");
  const steps: StepType[] = [
    {
      selector: '[data-tour="step-1"]',
      content: (
        <TourStep
          text={t("components.Tour.firstStep")}
          icon={<FontAwesomeIcon icon={faListOl} />}
        />
      ),
    },
    {
      selector: '[data-tour="step-2"]',
      content: (
        <TourStep
          text={t("components.Tour.secondStep")}
          icon={<FontAwesomeIcon icon={faAddressCard} />}
        />
      ),
    },
    {
      selector: '[data-tour="step-3"]',
      content: (
        <TourStep
          text={t("components.Tour.ThirdStep")}
          icon={<FontAwesomeIcon icon={faPeopleArrows} />}
        />
      ),
    },
    {
      selector: '[data-tour="step-4"]',
      content: (
        <TourStep
          text={t("components.Tour.fourthStep")}
          icon={<FontAwesomeIcon icon={faChartLine} />}
        />
      ),
    },
    {
      selector: '[data-tour="step-5"]',
      content: (
        <TourStep
          text={t("components.Tour.fifthStep")}
          icon={
            <TourIcon
              className="tour-icon-yellow-active"
              style={{ width: "1em" }}
            />
          }
        />
      ),
    },
  ];

  return (
    <TourProvider
      steps={steps}
      showBadge={false}
      showNavigation={false}
      showCloseButton={false}
      onClickMask={() => {}}
      styles={{
        popover: (base) => ({ ...base, padding: "0 24px 0 0" }),
        close: (base) => ({ ...base, top: 0, right: 5, color: "#E64B4B" }),
      }}
      disableFocusLock
      position="right"
    >
      <WrappedTour>{children}</WrappedTour>
    </TourProvider>
  );
};

export default Tour;
